import React from 'react'
import Caption from '../Typography/Caption'
import config from 'constants/config'
import FormatDecimal from 'components/utils/Formatters/FormatDecimal'
import { getPlural } from 'lib/string/pluralize'

interface Props {
  value: number
  /**
   * @default neutral-two
   */
  colour?: 'neutral-two' | 'neutral-three'
}

function PriceRowPointsSale(props: Props) {
  const { value, colour = 'neutral-two' } = props

  return <Caption
    as="s"
    variant="medium"
    colour={colour}
  >
    Was <FormatDecimal value={value} />{getPlural(config.loyalty.pointsUnitAbbreviation)}
  </Caption>
}

export default PriceRowPointsSale
